import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import "./recruitment.css";
import BannerComponent from "../../components/bannerComponent/bannerComponent";
import PositionsApplySection from "../../components/positionsApplyComponent/positionsApplyComponent";
import ButtonLinkComponent from "../../components/buttonLink/buttonLink";

const Recruitment = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=RECRUITMENT";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("RECRUITMENT_TITLE"),
    text: t("JOIN_TALENT_POOL_TITLE"),
    className: "recruitmentHeroBanner",
    chipText: t("RECRUITMENT_TITLE_CARD"),
  };

  const featuresData = [
    {
      title: t("EXPERT_RECRUITERS"),
      text: t("EXPERT_RECRUITERS_DESC"),
      imgSrc: "/img/medium-shot-people-working-as-real-estate-agents 1.png",
    },
    {
      title: t("PERSONALIZED_APPROACH"),
      text: t("PERSONALIZED_APPROACH_DESC"),
      imgSrc: "/img/tailor solutions 1.png",
    },
    {
      title: t("PROVEN_TRACK_RECORD"),
      text: t("PROVEN_TRACK_RECORD_DESC"),
      imgSrc: "/img/empire-state-building-day 1.png",
    },
  ];

  const cardBenefitsData = [
    {
      icon: "Needs Assessment.svg",
      title: t("NEEDS_ASSESSMENT"),
      text: t("NEEDS_ASSESSMENT_DESC"),
    },
    {
      icon: "Candidate Search.svg",
      title: t("CANDIDATE_SEARCH"),
      text: t("CANDIDATE_SEARCH_DESC"),
    },
    {
      icon: "Screening and Interviewing.svg",
      title: t("SCREENING_AND_INTERVIEWING"),
      text: t("SCREENING_AND_INTERVIEWING_DESC"),
    },
    {
      icon: "CandidatePresentation.svg",
      title: t("CANDIDATE_PRESENTATION"),
      text: t("CANDIDATE_PRESENTATION_DESC"),
    },
    {
      icon: "FinalSelection.svg",
      title: t("FINAL_SELECTION_AND_ONBOARDING"),
      text: t("FINAL_SELECTION_AND_ONBOARDING_DESC"),
    },
  ];

  const partners = [
    { src: "/img/image Microsoft.png", alt: "Microsoft", className: "imageMicrosoft" },
    { src: "/img/image Udemy.png", alt: "Udemy", className: "imageUdemy" },
    { src: "/img/image Coursera.png", alt: "Coursera", className: "imageCoursera" },
    { src: "/img/image Google.png", alt: "Google", className: "imageGoogle" },
    { src: "/img/image IBM.png", alt: "IBM", className: "imageIBM" },
    { src: "/img/image Platzi.png", alt: "Platzi", className: "imagePlatzi" },
  ];

  function FeatureCard({ img, title, text }) {
    return (
      <article className="recruitmentFeatureCard">
        <div className="recruitmentFeatureContent">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
        <div className="recruitmentFeatureMedia">
          <img src={img} alt={title} />
        </div>
      </article>
    );
  }

  function StepsCards({ title, cardsData }) {
    return (
      <section className="recruitmentSteps">
        <div className="recruitmentSectionIntro">
          <h2>{title}</h2>
        </div>

        <div className="recruitmentStepsTimeline">
            {cardsData.map((data, index) => (
                <article className="recruitmentStepCard" key={index}>
                <div className="recruitmentStepTop">
                    <div className="recruitmentStepNumber">{index + 1}</div>
                </div>

                <h3>{data.title}</h3>
                <p>{data.text}</p>
                </article>
            ))}
        </div>
      </section>
    );
  }

  return (
    <>
      <Header />

      <main className="recruitmentPage">
        <section className="recruitmentHero recruitmentHeroFull">
          <div className="recruitmentHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("FIND_YOUR_NEXT_TALENT")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="recruitmentFeatures">
            <div className="recruitmentFeaturesWrap">
                <div className="recruitmentSectionIntro recruitmentSectionIntro--inside">
                <h2>
                    {t("WE_OFFER")}
                </h2>
                <p>
                    {t("RECRUITMENT_TEXT")}
                </p>
                </div>

                <div className="recruitmentFeaturesGrid">
                {featuresData.map((feature, index) => (
                    <FeatureCard
                    key={index}
                    title={feature.title}
                    text={feature.text}
                    img={feature.imgSrc}
                    />
                ))}
                </div>
            </div>
        </section>

        <section className="recruitmentPartners">
            <div className="recruitmentSectionIntro">
                <h2>{t("OUR_PARTNERS")}</h2>
            </div>

            <div className="recruitmentPartnersMarquee">
                <div className="recruitmentPartnersTrack">
                {[...partners, ...partners].map((image, index) => (
                    <div className="recruitmentPartnerItem" key={index}>
                    <img
                        src={image.src}
                        alt={image.alt}
                        className={`recruitmentPartnerLogo ${image.className}`}
                    />
                    </div>
                ))}
                </div>
            </div>
        </section>

        <StepsCards
          title={t("STEP_BY_STEP")}
          cardsData={cardBenefitsData}
        />

        <section className="recruitmentJobs">
            <div className="recruitmentJobsWrap">
                <PositionsApplySection title={t("FEATURED_JOBS")} />
            </div>
        </section>

        <section className="recruitmentCta">
          <div className="recruitmentCtaInner">
            <div className="recruitmentCtaContent">
              <h2>{t("FIND_YOUR_NEXT_TALENT")}</h2>
              <div className="recruitmentCtaText">
                <p>
                  {t("RECRUITMENT_CTA", {
                    defaultValue:
                      "Conecte con talento calificado y encuentre al próximo profesional ideal para su equipo.",
                  })}
                </p>
              </div>
            </div>

            <ButtonLinkComponent
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=RECRUITMENT"
              }
              blank={true}
              translateButton={t("FIND_YOUR_NEXT_TALENT")}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Recruitment;